export enum TViewLayout {
  Grid = 'grid',
  List = 'list',
}
